module.exports = __webpack_public_path__ + "static/nitt-3d25bf45d8577c794c1e2183410761be.png";